<div class="spinner-wrapper">
  <app-spinner [message]=message></app-spinner>
</div>
